<script>
import { ref, computed, inject } from '@vue/composition-api';
import { MapBoxMixin } from '@/mixins/MapBoxMixin';

export default {
    name: 'RoutePolyline',
    mixins: [MapBoxMixin],
    props: {
        pinnedDriverDetails: {
            type: Object,
            default: () => {}
        },
        isDateToday: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            routeId: null,
            routeLine: null,
            options: null,
            pattern: '-route-line'
        };
    },
    setup(props, context) {
        const { getters } = inject('vuex-store');
        const map = inject('map');
        const route = ref(null);
        const pinnedRoute = computed(() => getters['map/pinnedRoute']);
        const isPlannedRouteToggled = computed(() => getters['map/isPlannedRouteToggled']);
        const pinnedUser = computed(() => getters['map/pinnedUser']);

        return {
            route,
            pinnedRoute,
            map,
            isPlannedRouteToggled,
            pinnedUser
        };
    },
    render: () => null,
    watch: {
        isDateToday(newVal) {
            if (newVal) {
                this.createRouteLine();
            } else {
                this.removeRouteLine();
            }
        },
        isPlannedRouteToggled(newVal) {
            if (newVal) {
                this.createRouteLine();
            } else {
                this.removeRouteLine();
            }
        },
        async pinnedRoute(newVal) {
            if (newVal && this.pinnedDriverDetails) {
                const {
                    markerPins: { color }
                } = this.pinnedDriverDetails;

                this.options = {
                    strokeColor: color,
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    zIndex: 3
                };

                if (!this.isPlannedRouteToggled) {
                    this.removeRouteLine();
                }

                // Mapbox uses [longitude, latitude], so convert the array
                const path = this.$_mapbox_createPath(newVal);

                const routeLineData = this.$_mapBox_createRouteData(path);
                this.routeLine = [routeLineData];

                this.routeId = `${this.pinnedDriverDetails.publicUserId}${this.pattern}`;
                this.createRouteLine();
            }

            if (this.pinnedDriverDetails) {
                if (newVal) {
                    this.deleteUnpinnedRouteLines();
                } else {
                    this.removeRouteLine();
                }
            }
        },
        async pinnedUser(newVal) {
            if (!newVal) {
                this.removeRouteLine();
            }
        }
    },
    methods: {
        removeRouteLine(routeId = this.routeId) {
            this.$_mapBox_removeRoute(routeId, this.map);
        },
        createRouteLine() {
            this.$_mapBox_createRouteLine(this.routeLine, this.map, this.routeId, this.options);
        },
        deleteUnpinnedRouteLines() {
            const routes = this.getAllRouteLines();
            if (!routes?.matchingLayers) 
                return;

            routes.matchingLayers.forEach((route) => {
                if (route.id !== this.routeId) {
                    this.removeRouteLine(route.id);
                }
            });
        },
        getAllRouteLines() {
            const matchingLayers = [];
            const matchingSources = [];

            // Iterate through all layers
            this.map.getStyle().layers.forEach((layer) => {
                if (layer.id.includes(this.pattern)) {
                    matchingLayers.push(layer);
                }
            });

            // Iterate through all sources
            const { sources } = this.map.getStyle();
            Object.keys(sources).forEach((sourceId) => {
                if (sourceId.includes(this.pattern)) {
                    matchingSources.push({ id: sourceId, source: sources[sourceId] });
                }
            });

            return { matchingLayers, matchingSources };
        }
    }
};
</script>
